/** Runtime config for the client portal, served at /env.js (window.__ENV__) from App Service settings. */

declare global {
  interface Window {
    __ENV__?: { apiUrl?: string; environment?: string; turnstileSiteKey?: string };
  }
}

export const API_BASE: string = window.__ENV__?.apiUrl ?? "http://localhost:5100";

/** Development | Staging | Production — drives the env badge (hidden in Production on the client portal). */
export const APP_ENVIRONMENT: string = window.__ENV__?.environment ?? "Development";

/**
 * Cloudflare Turnstile site key. Empty until the prod key is set in App Service settings — the widget
 * then renders nothing and the form submits without a token (the backend verifier fails open while
 * Turnstile is unconfigured). See spec §8.1.
 */
export const TURNSTILE_SITE_KEY: string = window.__ENV__?.turnstileSiteKey ?? "";

export {};
